import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Re-exportar todo lo que los microfrontends necesiten
export {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  type AuthError,
  type User,
} from 'firebase/auth'

const firebaseConfigSofka = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
}

const app = initializeApp(firebaseConfigSofka)
export const auth = getAuth(app)

export default app
